import React from "react";
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import performRequest from "../api/request";
import { Toast } from "../CustomComponent/toast";
import { FcViewDetails } from "react-icons/fc";
import Footer from "../Components/Footer/footer";
import { CustomErrorResponse } from "../CustomComponent/custom_error_response";
import LoadingPage from "../Components/layouts/loading";
import "react-datepicker/dist/react-datepicker.css";
import FormSubmitButton from "../Components/layouts/formSubmitButton";

function CancelSiSchedules() {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [isDateExpired, setIsDateExpired] = useState(false);
  const [data, setData] = useState([]);
  const handleCancelSchedule = () => {
    if (id) {
      setLoading(true);
      performRequest("POST", `/bookSiteInspection/cancelSISchedules/${id}`)
        .then((res) => {
          if (res.status === 200) {
            Toast("success", "Schedule Cancel Successfully");
          }
        })
        .catch((err) => {
          CustomErrorResponse(err);
        })
        .finally(() => setLoading(false));
        window.location.reload()
    }
  };

  const checkDate = (inputDate) => {
    const [day, month, year] = inputDate.split("-").map(Number);
    const inputDateObj = new Date(year, month - 1, day);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (inputDateObj.getTime() === today.getTime()) {
      setIsDateExpired(true);
    }
  };

  const findMinimumDate = (data) => {
    if (!data || data.length === 0) return null;

    return data.reduce((min, current) =>
      new Date(current.prefferedDate.split("-").reverse().join("-")) <
      new Date(min.prefferedDate.split("-").reverse().join("-"))
        ? current
        : min
    ).prefferedDate;
  };

  useEffect(() => {
    setLoading(true)
    performRequest("GET", `/bookSiteInspection/getOrderIdCount/${id}`)
      .then((res) => {
        if (res.status === 200) {
            
          if (!res.data?.getData) {
            let data = [res.data.verifyOrderId];
            setData(data);    
            let checkingData = res.data.verifyOrderId.finalDate;
            checkDate(checkingData);
          } else {
            setData(res.data.getData);
            let minDate = findMinimumDate(res.data.getData);
            checkDate(minDate);
          }
        }
      })
      .catch((err) => {
        if (err?.response?.data?.message) {
          Toast("error", err?.response?.data?.message);
        } else {
          Toast("error", err);
        }
      }).finally(()=>setLoading(false));
  }, []);

  if (loading) {
    return <LoadingPage />;
  }


  if (isDateExpired) {
    return (
      <>
        <div className="page d-flex justify-content-center align-items-center">
          <div className="container-xl">
            <div className="row justify-content-center">
              <div className="col-md-8">
                <div className="card shadow-sm">
                  <div className="card-body text-center">
                    <h4 clasName="">Important Notice</h4>
                    <p>
                      It seems the rescheduling and cancellation period for your
                      appointment has passed. We understand that unexpected
                      situations can arise, and we sincerely apologize for any
                      inconvenience caused. Our support team is here to assist
                      you with any further concerns or questions.
                    </p>
                    <p>
                      Please feel free to <a href="#">contact our team</a> for
                      personalized assistance. We will do our best to help you
                      in any way possible.
                    </p>
                    <p>Thank you for your understanding and cooperation.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <div className="page">
        <div className="page-wrapper">
        {(data[0]?.finalDate || data.length>0 ) ? (  <div className="container-xl">
            <div className="page-header d-print-none">
                
              <div className="row g-2 align-items-center">
                <div className="col">
                  <h2 className="page-title mb-1">
                    <FcViewDetails className="fs-2 me-1" />
                    Cancel Site Inspection
                  </h2>
                </div>
              </div>
            </div>
            <div className="card my-4">
              <div className="card-header">
                <h2 className="page-title">Cancel Site Schedules</h2>
              </div>

              <div className="card-body">
                <div className="row">
                  <div className="col-12">
                    <div className="mb-3 row">
                      <label className="form-label col-lg-3">Name</label>
                      <div className="col-lg-9">
                        {data[0]?.fullName || "N/A"}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="form-label col-lg-3">Email</label>
                      <div className="col-lg-9">{data[0]?.email || "N/A"}</div>
                    </div>

                    <div className="mb-3 row">
                      <label className="form-label col-lg-3">
                        Contact Number
                      </label>
                      <div className="col-lg-9">
                        {data[0]?.contactNumber || "N/A"}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="form-label col-lg-3">
                        {data?.[0]?.finalDate
                          ? "Finalized Schedule"
                          : "Preffered Schedule"}
                      </label>

                      {data?.map((item, index) => (
                        <div key={index} className="col-lg-3">
                          <div className={`card my-1 `}>
                            <div className="card-body">
                              <p className="card-text">
                                {`Date: ${
                                  item?.finalDate
                                    ? item?.finalDate
                                    : item?.prefferedDate
                                }`}
                                <br />
                                {`Time: ${item?.timeSlot}`}
                              </p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-footer">
                <div className="btn-list justify-content-end">
                  <FormSubmitButton
                    
                    onClick={handleCancelSchedule}
                    buttonText="Cancel Schedule"
                  />
                </div>
              </div>
            </div>
          </div>) : (<div className="d-flex justify-content-center align-items-center vh-100 bg-light">
      <div className="card shadow-lg p-5" style={{ maxWidth: '480px', width: '100%' }}>
        <div className="text-center">
          <h1 className="text-danger fw-bold">Site Inspection Canceled</h1>
          <p className="text-muted mt-3">
            Your site inspection schedule has been canceled. If you have any concerns or would like further assistance, please reach out to us.
          </p>
          <hr className="my-4" />
          <p className="text-muted">
            A confirmation has been sent to your registered email address. Please check your inbox.
          </p>
          <p className="text-muted">
            Need further assistance? Contact our support team at:
          </p>
          <div className="mt-3">
            <p className="text-primary fw-semibold mb-1">Email: contact@kryzen.com</p>
            <p className="text-primary fw-semibold">Mobile: 9870-424-425</p>
          </div>
        </div>
      </div>
    </div>) }
        
          <Footer />
        </div>
      </div>
    </>
  );
}

export default CancelSiSchedules;
